import { TABLET_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';
import { CreateIntegrationReadyDeliveryStoreParams } from '@/services/StoreManagement/IntegrationReadyDeliveryStore/hooks/useCreateIntegrationReadyDeliveryStore';
import { ListIntegrationReadyDeliveryStoreResponse } from '@/services/StoreManagement/IntegrationReadyDeliveryStore/hooks/useListIntegrationReadyDeliveryStore';
import { UpdateIntegrationReadyDeliveryStoreOrderManagerParams } from '@/services/StoreManagement/IntegrationReadyDeliveryStore/hooks/useUpdateIntegrationReadyDeliveryStoreOrderManager';

interface Interface {
  create(params: CreateIntegrationReadyDeliveryStoreParams[]): Promise<void>;
  updateOrderManager(
    params: UpdateIntegrationReadyDeliveryStoreOrderManagerParams
  ): Promise<void>;
}

export class IntegrationReadyDeliveryStoreService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async create(
    params: CreateIntegrationReadyDeliveryStoreParams[]
  ): Promise<void> {
    await this.restClient.post<
      CreateIntegrationReadyDeliveryStoreParams[],
      void
    >(
      `${TABLET_API_ORIGIN}/dashboard-api/integration-ready-delivery-stores` as const,
      params
    );
  }

  public async list(): Promise<ListIntegrationReadyDeliveryStoreResponse[]> {
    return await this.restClient.get<
      ListIntegrationReadyDeliveryStoreResponse[]
    >(
      `${TABLET_API_ORIGIN}/dashboard-api/integration-ready-delivery-stores` as const
    );
  }

  public async updateOrderManager(
    params: UpdateIntegrationReadyDeliveryStoreOrderManagerParams
  ): Promise<void> {
    await this.restClient.patch<
      UpdateIntegrationReadyDeliveryStoreOrderManagerParams,
      void
    >(
      `${TABLET_API_ORIGIN}/dashboard-api/integration-ready-delivery-stores/order-manager` as const,
      params
    );
  }
}
